import backofficeService from '../../api/backoffice'

export default {
  /**
   * Get list of products
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.local Add LocalData to products
   */
  getAll(params) {
    return backofficeService.Api().get('class', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  
  /**
   * Get specific product
   * @param {*} id
   * @param {*} params
   * @param {*} params.local Add LocalData to product
   */
  getById(id, params = {}) {
    return backofficeService.Api().get(`class/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  getClassInfo(params = {}) {
    return backofficeService.Api().get(`class/info`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  
  /**
   * Create a product. Will also initiate location data
   * @param {*} data
   */
  create(data) {
    return backofficeService.Api().post('class', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Update specific product
   * @param {*} id
   * @param {*} data
   */
  update(id, data) {
    return backofficeService.Api().put(`class/${id}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
     /**
   * Update specific product
   * @param {*} id
   * @param {*} data
   */
  updateClassStudent(id, data) {
    return backofficeService.Api().put(`classStudent/${id}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Create a product. Will also initiate location data
   * @param {*} data
   */
   assignStudent(data) {
    return backofficeService.Api().post(`classStudent`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getAssignTeacherList(params) {
    return backofficeService.Api().get(`classTeacher`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  assignTeacher(data) {
    return backofficeService.Api().post(`classTeacher`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  removeStudent(id, params) {
    return backofficeService.Api().delete(`classStudent/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  removeTeacher(id, params) {
    return backofficeService.Api().delete(`classTeacher/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Delete product
   * @param {} id
   * @param {*} params
   */
  delete(id, params) {
    return backofficeService.Api().delete(`class/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

}
